export default "__VITE_ASSET__DKWJ9it3__"